export default {
  chiropractor: 'Chiropractor',
  deathDismemberment: 'Death & Dismemberment',
  dental: 'Dental',
  dependentLife: 'Dependent Life',
  drugs: 'Drugs',
  hearing: 'Hearing Aids',
  lifeInsurance: 'Life Insurance',
  massage: 'Massage',
  naturopath: 'Naturopath',
  orthotics: 'Orthothics',
  osteopath: 'Osteopath',
  physiotherapy: 'Physiotherapy',
  podiatrist: 'Podiatrist',
  psychologist: 'psychologist',
  speech: 'Speech Therapy',
  vision: 'Vision'
};